import timeFormatter from '@frontend/utils/timeFormatter'

export type RoleOption = { value: string; label: string }

export const roleOptionsFor = (roles: string[]): RoleOption[] => roles.map((role) => ({ value: role, label: role }))

export const loadRoleOptions =
  (options: RoleOption[]) =>
  (input: string): Promise<RoleOption[]> =>
    Promise.resolve(options.filter((option) => option.label.toLowerCase().includes(input.toLowerCase())))

export const dayOptionsFor = (dates: string[], zone?: string | null) =>
  dates.map((date) => ({ value: date, label: timeFormatter.fromISO(date, zone).toLongDate() }))
